import {Box, Button, IconButton, Stack} from "@mui/material";
import {useEffect, useMemo, useState} from "react";
import {LiaBroomSolid} from "react-icons/lia";
import useApiRequest from "../../hooks/useApiRequest";
import SearchAutocomplete from "../ui/SearchAutocomplete";

const normalizeArray = (value) => {
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.results)) return value.results;
  if (Array.isArray(value)) return value;
  return [];
};

const RoleScopesFilterBar = ({roleId, onSearch}) => {
  const [filterProductId, setFilterProductId] = useState("");
  const [filterProductInput, setFilterProductInput] = useState("");
  const [filterProductValue, setFilterProductValue] = useState(null);
  const [productLookupTerm, setProductLookupTerm] = useState("");

  const {
    data: dataFilterProducts,
    loading: loadingFilterProducts,
    list: listFilterProducts
  } = useApiRequest({baseUrl: "/products", resource: "products"});

  useEffect(() => {
    listFilterProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilterProductId("");
    setFilterProductInput("");
    setFilterProductValue(null);
    setProductLookupTerm("");
    onSearch({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleId]);

  const allProductOptions = useMemo(
    () => normalizeArray(dataFilterProducts).map((p) => ({id: p.id, label: p.name || p.id})),
    [dataFilterProducts]
  );

  const filterProductOptions = useMemo(() => {
    const normalizedLookupTerm = productLookupTerm.trim().toLowerCase();

    if (!normalizedLookupTerm) {
      return allProductOptions;
    }

    return allProductOptions.filter((product) => product.label.toLowerCase().includes(normalizedLookupTerm));
  }, [allProductOptions, productLookupTerm]);

  const buildParams = ({pId = filterProductId} = {}) => {
    const params = {};
    if (pId) params.product_id = pId;
    return params;
  };

  const handleSearch = () => {
    const params = buildParams();
    onSearch(params);
  };

  const handleProductLookup = () => {
    const term = filterProductInput.trim();
    setProductLookupTerm(term);
  };

  const handleClear = () => {
    setFilterProductId("");
    setFilterProductInput("");
    setFilterProductValue(null);
    setProductLookupTerm("");

    listFilterProducts();

    onSearch({});
  };

  return (
    <Box sx={{mb: 2}}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <SearchAutocomplete
          label="Producto"
          options={filterProductOptions}
          loading={loadingFilterProducts}
          value={filterProductValue}
          inputValue={filterProductInput}
          onInputChange={(_, v) => setFilterProductInput(v)}
          onChange={(_, value) => {
            setFilterProductValue(value);
            setFilterProductId(value?.id || "");
          }}
          onSearch={handleProductLookup}
        />
        <Button variant="contained" size="small" onClick={handleSearch}>
          Aplicar
        </Button>
        <IconButton onClick={handleClear}>
          <LiaBroomSolid />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default RoleScopesFilterBar;
